import React from 'react';
import get from 'lodash/get';
import { MenuItem } from 'material-ui';
import { green200 } from 'material-ui/styles/colors';
import { connect } from 'react-redux';
import { getEntities } from 'dash-front/selectors';
import { toggleSelection, oddsSelection } from './actions';
import { resolveOutcomeText } from './utils';

const rowStyle = { display: 'flex', minWidth: 150, margin: '0px 6px', justifyContent: 'space-between' };

export const OutcomeItem = connect(
    (state, { id, eventId }) => ({
        event: get(getEntities(state).events, eventId),
        outcome: get(getEntities(state).outcomes, [id]),
        checked: Boolean(oddsSelection.select(state).selected[id])
    }),
    dispatch => ({
        onClick: id => dispatch(toggleSelection(id))
    })
)(
    class extends React.Component {
        onClick = () => {
            const { id, onClick } = this.props;
            onClick(id);
        };

        render() {
            const { onClick, checked, outcome, event, eventId, dispatch, ...rest } = this.props;
            return (
                <MenuItem
                    {...rest}
                    onTouchTap={this.onClick}
                    style={{ border: '1px solid #ccc', backgroundColor: checked ? green200 : undefined }}
                >
                    <div style={rowStyle}>
                        <div style={{ marginRight: 4 }}>{resolveOutcomeText(outcome, event)}</div>
                        <div>{outcome && outcome.odds}</div>
                    </div>
                </MenuItem>
            );
        }
    }
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/OutcomeItem.js
 **/